import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ProcessVideo from './processvideo/ProcessVideo'
import CEO from './home/CEO';
import Login from './login/Login';
import UserRole from './userrole/UserRole';
import 'primereact/resources/themes/lara-light-blue/theme.css';  // Choose your preferred theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'; // Optional: If you use PrimeFlex for layout
import UserActivity from './userlogs/UserActivity';
import LoginHome from './login/LoginHome';





function App() {
  return (
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/fruitveg" element={<ProcessVideo />} />
          <Route path="/cfc" element={<ProcessVideo />} />
          <Route path="/bakery" element={<ProcessVideo />} />
          <Route path="/butchery" element={<ProcessVideo />} />
          <Route path="/takeaway" element={<ProcessVideo />} />
          <Route path="/brmanager" element={<ProcessVideo />} />
          <Route path="/ceo" element={<CEO />} />
          <Route path="/home" element={<LoginHome />} />
          <Route path="/userrole" element={<UserRole />} />
          <Route path="/activitylogs" element={<UserActivity />} />
        </Routes>
      </div>
  );
}

export default App;
